import styled from "styled-components";

export const InfoSec = styled.div`
  padding: 140px 0px;
  background: ${({ light }) => (light ? "white" : "#0a0806")};
`;

export const InfoContainer = styled.div`
  padding-left: 30px;
  padding-right: 30px;
  width: 97%;
  max-width: 1400px;
  margin-right: auto;
  margin-left: auto;
  border-top: 2px solid #000000;
  border-bottom: 2px solid #000000;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin: 30px -15px 15px -15px;
  flex-direction: row-reverse;

  @media screen and (max-width: 1191px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const InfoColumn = styled.div`
  margin-bottom: 15px;
  margin-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1191px) {
    max-width: 100%;
    flex-basis: 100%;
  }
`;

export const TextWrapper = styled.div`
  max-width: 640px;
  padding-top: 15px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ light }) =>
      light
        ? "linear-gradient(#e53935, #e57373)"
        : "linear-gradient(#37615b, #5dc1b9)"}
    no-repeat;
  border-radius: 20px;

  @media screen and (max-width: 960px) {
    padding-bottom: 65px;
  }
`;

export const InfoSecGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 220px);
  gap: 40px;
  width: 100%;
  justify-content: center;
  padding: 20px;
`;

export const InfoSecSkill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoSecImg = styled.div`
  color: ${({ light }) => (light ? "white" : "#5dc1b9")};
  font-size: 26px;
`;

export const InfoSecSkillMeta = styled.div`
  display: flex;
  justify-content: center;
`;

export const InfoSecText = styled.h3`
  font-size: 22px;
  color: #272727;
  font-weight: bold;
  text-align: center;

  @media screen and (max-width: 960px) {
    font-size: 20px;
  }
`;

export const InfoSecp = styled.p`
  margin-top: 10px;
  color: #272727;
  font-size: 15px;
  text-align: center;
`;

export const TopLine = styled.div`
  display: flex;
  justify-content: center;
  color: #0a0806;
  font-size: 35px;
  line-height: 16px;
  letter-spacing: 1.4px;
  margin-bottom: 20px;
  font-weight: bold;
  padding: 20px;

  @media screen and (max-width: 960px) {
    font-size: 28px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  display: flex;
  justify-content: center;
  text-align: center;
  color: ${({ light }) => (light ? "white" : "#42a8a1")};
  padding: 0px 20px;

  @media screen and (max-width: 960px) {
    font-size: 35px;
  }
`;

export const Subtitle = styled.p`
  text-align: center;
  max-width: 540px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #272727;
  padding: 0px 20px;

  @media screen and (max-width: 960px) {
    font-size: 15px;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: "center";
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
  border-radius: 10px;
`;
